<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="标题" name="name"></c-form-item>
                    <c-form-item type="datetime" label="发布时间" start-name="start_create_date" end-name="end_create_date"></c-form-item>
<!--                    <c-form-item type="select" label="所属栏目" name="column_type" :options="columnType"></c-form-item>-->
                    <c-form-item type="select" label="所属栏目" name="type_id" options="ABSTRACT_TYPE_ID"></c-form-item>
                </c-form>
            </m-search>
            <m-operate>
                <c-button color="sys" icon="add" @click="navigateTo(`/abstract_consultation_add`)" power="b_abstract_consultation_edit">添加资讯</c-button>
                <c-button  @click="openTypeManage()" power="b_abstract_consultation_type_manage">栏目管理</c-button>
            </m-operate>

            <c-table ref="table" code="abstract_consultation">
                <c-table-column
                        label="标题"
                        name="name"
                        width="300"
                >
                </c-table-column>

                <c-table-column
                        label="所属栏目"
                        name="type_name"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="发布时间"
                        name="create_date"
                        width="150"
                >
                </c-table-column>

                <c-table-column
                        label="是否启用"
                        name="state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state==2"><span style="color:darkgreen">启用</span></span>
                        <span v-if="data.state!=2"><span style="color:#999999">禁用</span></span>
                    </template>
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        @sort="sortHandle"
                        width="120"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="170"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_abstract_consultation_view" @click="navigateTo(`/abstract_consultation_edit/${data.id}`)">查看</c-table-button>
                        <c-table-button power="b_abstract_consultation_edit" v-if="data.state == 1"  @click="updateState(2,data)">启用</c-table-button>
                        <c-table-button power="b_abstract_consultation_edit" v-if="data.state == 2"  @click="updateState(1,data)">禁用</c-table-button>
                        <c-table-button power="b_abstract_consultation_edit" @click="navigateTo(`/abstract_consultation_edit/${data.id}`)">编辑</c-table-button>
                        <c-table-button power="b_abstract_consultation_edit" @click="deleteHandle(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <c-dialog ref="typeDialog" title="栏目管理" width="800" :button="false">

            <m-operate>
                <c-button color="sys"  @click="openAddTypeDia" power="b_abstract_consultation_type_manage">新增</c-button>
            </m-operate>

            <c-table ref="typeTable" height="500">
                <c-table-column
                        label="栏目名称"
                        name="name"
                        width="300"
                >
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="150"
                >
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        @sort="sortTypeHandle"
                        width="120"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="170"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_abstract_consultation_type_manage" @click="openEditTypeDia(data)">编辑</c-table-button>
                        <c-table-button power="b_abstract_consultation_type_manage" @click="deleteTypeHandle(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>

        <c-dialog ref="typeEdit" :title="editState ? '编辑栏目' : '新增栏目'" width="600" @resolve="editTypeHandle">
            <c-form ref="typeForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="input" label="栏目名称" name="name" required></c-form-item>
            </c-form>
        </c-dialog>

    </page>
</template>

<script>
    var name = 'm_abstract_consultation';
    var urls = {
        list:'/abstract_consultation/list', //列表数据
        del:'/abstract_consultation/del', //删除
        sort:'/abstract_consultation/sort', //排序
        state:'/abstract_consultation/state', //启禁用
        recommend:'/abstract_consultation/recommend' //推荐
    }
    export default {
        name: name,

        data() {
            return {
                columnType:[
                    {name:'全部',value:''},
                    {name:'前沿快讯',value:1},
                    {name:'生物精选',value:2},
                    {name:'专业文摘',value:3}
                ],
                columnTypeName: {
                    1: '前沿快讯',
                    2: '生物精选',
                    3: '专业文摘'
                },
                editState: false
            }
        },

        mounted() {
            this.$refs.search.search();

            this.$bus.$on('m_abstract_consultation.update', page => {
                this.$refs.table.update(page);
            });
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: urls.list,
                    data
                });
            },

            editHandle(row) {
                this.editState = true;
                this._edit = row.data.id;
                this._resolve = data => {
                    row.update(data);
                };
                this.$refs.form.set(row.data);
                this.$refs.dialog.open();
            },

            updateState(type,val) {
                this.$confirm({
                    text: '确定要'+(type==2?'启用':'禁用')+'【'+val.name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: urls.state,
                            data: {id:val.id,state:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            updateRecommendedState(type,val) {
                this.$confirm({
                    text: '确定'+(type==1?'推荐':'不推荐')+'【'+val.name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: urls.recommend,
                            data: {id:val.id,is_recommend:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            deleteHandle(val) {

                this.$confirm({
                    text: '确定要删除【'+val.name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: urls.del,
                            data: {id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            deleteTypeHandle(val){
                this.$confirm({
                    text: '确定要删除【'+val.name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/abstract_consultation_type/del',
                            data: {id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.typeTable.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            sortHandle(row, type, next) {
                this.request({
                    url: urls.sort,
                    data: {
                        id: row.data.id,
                        parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
                        type: ['top', 'bottom'].includes(type) ? type : '',
                        id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
                        id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
                    },
                    loading: true,
                    success: data => {
                        if (type == 'top' || type == 'bottom') {
                            this.$refs.table.update();
                        } else {
                            next();
                        }
                    }
                });
            },

            sortTypeHandle(row, type, next) {
                this.request({
                    url: '/abstract_consultation_type/sort',
                    data: {
                        id: row.data.id,
                        parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
                        type: ['top', 'bottom'].includes(type) ? type : '',
                        id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
                        id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
                    },
                    loading: true,
                    success: data => {
                        next();
                    }
                });
            },

            openTypeManage(){
                this.$refs.typeDialog.open();
                this.$refs.typeTable.load({
                    url: '/abstract_consultation_type/list',
                    dataFormatter: data => {
                        return data;
                    }
                });
            },

            openAddTypeDia(){
                this.editState = false;
                this.$refs.typeEdit.open();
                this.$refs.typeForm.clear();
            },

            openEditTypeDia(val){
                this.editState = true;
                this.$refs.typeForm.set(val);
                this.$refs.typeEdit.open();
            },

            editTypeHandle(stop) {
                stop();
                this.$refs.typeForm.submit({
                    url: this.editState ? '/abstract_consultation_type/update' :'/abstract_consultation_type/add',
                    rule: {
                        name: '请填写栏目标题'
                    },
                    success: () => {
                        this.$refs.typeTable.update();
                        this.$refs.typeEdit.close();
                    }
                });
            },

        }
    }
</script>
